var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"categories-section",class:_vm.putClass},_vm._l((_vm.categories),function(value,name,index){return _c('div',{key:index,staticClass:"categories-item",style:({
      'background-image': `url(./categories/${value.photo})`,
    }),on:{"click":function($event){return _vm.chooseEl(value.name, $event)}}},[_c('div',{staticClass:"bg"},[_c('div',{staticClass:"text-content"},[_vm._v(_vm._s(value.name))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }